import { isDevOrSandbox } from '../../../utils';
import {
  BuildEnableSaveConnectorButtonStateArgs,
  BuildEnableSaveConnectorButtonStateReturn,
} from './model';

export const buildEnableSaveConnectorButtonState = ({
  models,
  sources,
  repeatedSource,
  allSourcesHaveModels,
}: BuildEnableSaveConnectorButtonStateArgs): BuildEnableSaveConnectorButtonStateReturn => {
  if (isDevOrSandbox()) {
    return models && sources && allSourcesHaveModels;
  }

  return models && sources && !repeatedSource && allSourcesHaveModels;
};
